import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { label: 'Home', path: '/browse', description: 'Browse all content' },
  { label: 'TV Shows', path: '/tv-shows', description: 'Browse TV shows' },
  { label: 'Movies', path: '/movies', description: 'Browse movies' },
  { label: 'New & Popular', path: '/new-popular', description: 'Discover new and trending content' },
  { label: 'My List', path: '/my-list', description: 'View your saved content' },
  { label: 'Networking', path: '/networking', description: 'Connect with other creators' },
];

export const DesktopNav = ({ isDark }) => {
  const location = useLocation();

  return (
    <nav 
      className="hidden lg:flex items-center gap-1 ml-6" 
      data-testid="desktop-nav"
      role="navigation"
      aria-label="Main navigation"
    >
      <ul className="flex items-center gap-1" role="menubar">
        {NAV_ITEMS.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <li key={item.path} role="none">
              <Link 
                to={item.path}
                role="menuitem"
                aria-current={isActive ? 'page' : undefined}
                aria-label={`${item.label}${isActive ? ' (current page)' : ''}`}
                className={`
                  px-3 py-2 rounded-lg text-sm transition-all
                  focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400 focus-visible:ring-offset-2
                  ${isActive 
                    ? isDark 
                      ? 'text-white font-medium bg-white/5' 
                      : 'text-gray-900 font-medium bg-gray-100'
                    : isDark
                      ? 'text-gray-400 hover:text-white hover:bg-white/5'
                      : 'text-gray-500 hover:text-gray-900 hover:bg-gray-100'
                  }
                `}
              >
                {item.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export { NAV_ITEMS };
export default DesktopNav;
